export default __webpack_public_path__ + "static/media/intellij-icon.16397e34.svg";